// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme from "../../styles/Theme.bs.js";
import * as Emotion from "../../bindings/Emotion.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function Badge$Badge(props) {
  let __className = props.className;
  let __variant = props.variant;
  let variant = __variant !== undefined ? __variant : "default";
  let className = __className !== undefined ? __className : "";
  let baseStyles = Emotion.Css.css({
    display: "inline-flex",
    alignItems: "center",
    fontFamily: Theme.Theme.Typography.fontFamily.sans,
    fontSize: "0.6875rem",
    fontWeight: "500",
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    padding: "0.25rem 0.625rem",
    borderRadius: "2px",
    lineHeight: "1.25"
  });
  let variantStyles = variant === "primary" ? Emotion.Css.css({
      backgroundColor: Emotion.Utils.Color.primary + `1a`,
      color: Emotion.Utils.Color.primary,
      border: `1px solid ` + Emotion.Utils.Color.primary + `33`
    }) : (
      variant === "warning" ? Emotion.Css.css({
          backgroundColor: "rgba(245, 158, 11, 0.1)",
          color: Emotion.Utils.Color.warning,
          border: "1px solid rgba(245, 158, 11, 0.2)"
        }) : (
          variant === "default" ? Emotion.Css.css({
              backgroundColor: Emotion.Utils.Color.bgElevated,
              color: Emotion.Utils.Color.textSecondary,
              border: `1px solid ` + Emotion.Utils.Color.border
            }) : (
              variant === "success" ? Emotion.Css.css({
                  backgroundColor: "rgba(34, 197, 94, 0.1)",
                  color: Emotion.Utils.Color.success,
                  border: "1px solid rgba(34, 197, 94, 0.2)"
                }) : Emotion.Css.css({
                  backgroundColor: "rgba(239, 68, 68, 0.1)",
                  color: Emotion.Utils.Color.error,
                  border: "1px solid rgba(239, 68, 68, 0.2)"
                })
            )
        )
    );
  let badgeClassName = Emotion.Css.cx([
    baseStyles,
    variantStyles,
    className
  ]);
  return JsxRuntime.jsx("span", {
    children: props.children,
    className: badgeClassName
  });
}

let Badge = {
  make: Badge$Badge
};

export {
  Badge,
}
/* Theme Not a pure module */
